import { render, staticRenderFns } from "./JobFairDetail.vue?vue&type=template&id=ecae463a&scoped=true&"
import script from "./JobFairDetail.vue?vue&type=script&lang=ts&"
export * from "./JobFairDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobFairDetail.vue?vue&type=style&index=0&id=ecae463a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecae463a",
  null
  
)

export default component.exports